import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

var _a = createMultiStyleConfigHelpers(inputAnatomy.keys), definePartsStyle = _a.definePartsStyle, defineMultiStyleConfig = _a.defineMultiStyleConfig;
var outline = definePartsStyle({
    field: {
        border: '1px solid',
        borderColor: 'neutrals.600',
        borderRadius: 'md',
        fontSize: '16px',
        '&:disabled ~ .chakra-input__right-addon': {
            border: '1px solid',
            borderColor: 'neutrals.400 !important',
            color: 'neutrals.500'
        },
        _hover: {
            border: '2px solid',
            borderColor: 'neutrals.600 !important',
            paddingLeft: "11px",
        },
        _invalid: {
            border: '2px solid',
            borderColor: 'error.500 !important',
            boxShadow: 'none',
            _focusVisible: {
                border: '2px solid',
                borderColor: 'error.500 !important',
            },
        },
        _focusVisible: {
            border: '2px solid',
            borderColor: 'focused !important',
            boxShadow: 'shadow-low',
        },
        _disabled: {
            border: '1px solid',
            borderColor: 'neutrals.400',
            _hover: {
                border: '1px solid',
                borderColor: 'neutrals.400 !important',
            }
        },
        _focus: {
            border: "1px solid",
            paddingLeft: "12px"
        }
    },
    addon: {
        bg: 'neutrals.white',
        ml: '0 !important',
        border: '1px solid !important',
        borderColor: 'neutrals.600 !important',
        borderRadius: '0px 4px 4px 0px',
        fontSize: '16px'
    },
    element: {
        height: '100%',
    },
});
var filled = definePartsStyle({
    field: {
        border: '1px solid',
        borderColor: 'neutrals.600',
        borderRadius: 'md',
        bg: 'neutrals.white',
        fontSize: '16px',
        _focusVisible: {
            border: '2px solid',
            borderColor: 'secondary.900 !important',
            boxShadow: 'shadow-low !important'
        },
        _hover: {
            bg: 'neutrals.white'
        },
    },
});
var sizes = defineStyle({
    sm: {
        field: {
            width: '100%',
            height: '36px',
            px: 3,
            py: 2
        },
        addon: {
            height: '36px',
            px: 4,
            py: 2
        },
    },
    lg: {
        field: {
            '& ~ .chakra-input__right-addon': {
                height: '48px'
            },
            width: '100%',
            height: '48px',
            px: 3,
            py: '14px'
        },
        addon: {
            px: 4,
            py: '14px'
        },
    }
});
var inputTheme = defineMultiStyleConfig({
    defaultProps: {
        size: 'sm',
        variant: 'outline'
    },
    variants: { outline: outline, filled: filled },
    sizes: sizes
});

export { inputTheme };
//# sourceMappingURL=input.js.map
